module.exports = __webpack_public_path__ + "img/744.39e2d9d6.jpg";